import React, { useState } from "react";
import { Eye, EyeOff, Lock, Loader2, CheckCircle, AlertCircle, ShieldCheck } from 'lucide-react';
import axios from "axios";
import { useNavigate } from "react-router-dom"; 
import config from '../config/config';
function PasscodeLogin() {
    const navigate = useNavigate();
    const [passcode, setPasscode] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showPasscode, setShowPasscode] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const handleChange = (e) => {
        setPasscode(e.target.value);
        if (error) setError(null);
    };

  

     const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);
        if (!passcode.trim()) {
            setError("Please enter your passcode");
            return;
        }
        try {
            await new Promise(resolve => setTimeout(resolve, 1500));
            await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
                withCredentials: true,
            });

            const getCookie = (name) => {
                const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
                if (match) return decodeURIComponent(match[2]);
                return null;
            };
            const xsrfToken = getCookie("XSRF-TOKEN");

            const response = await axios.post(
                config.API_URL + "/api/payrollLogin",
                {password:passcode},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-XSRF-TOKEN": xsrfToken,
                    },
                    withCredentials: true,
                }
            );

            localStorage.setItem("token", response.data.token);
            localStorage.setItem("system_role", response.data.user);
          
            if(response.data.status==1){
               // setSuccess("Successfully logged in");

               // if(response.data.user=="Super Admin"){
                 setSuccess("Access granted");
                 navigate("/AdminCms");
                //}
            }else{
                setError("Login failed - Invalid credentials. Please try again.");
                
                 navigate("/Cms");
            }
           
        } catch (error) {
            setError("Login failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <div className="min-h-screen w-full bg-white flex items-center justify-center p-4 relative overflow-hidden">
            {/* Subtle background pattern */}
            <div className="absolute inset-0 opacity-[0.02]">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 2px 2px, rgb(2, 3, 129) 1px, transparent 0)`,
                    backgroundSize: '40px 40px'
                }}></div>
            </div>

            <div className="relative w-full max-w-md">
                {/* Main card */}
                <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 p-8 sm:p-12 relative overflow-hidden">
                    
                    {/* Logo and header */}
                    <div className="text-center mb-10">
                        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 mb-6 shadow-sm">
                            <ShieldCheck className="w-10 h-10 text-[#020381]" strokeWidth={1.5} />
                        </div>
                        
                        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                           Junisa CMS <br/> Secure Access
                        </h1>
                        <p className="text-gray-500 text-sm sm:text-base font-medium">
                            Enter your passcode to continue
                        </p>
                    </div>

                    {/* Alerts */}
                    {success && (
                        <div className="mb-6 p-4 bg-green-50 border border-green-100 rounded-xl flex items-center space-x-3 animate-pulse">
                            <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                            <span className="text-green-700 font-medium text-sm">{success}</span>
                        </div>
                    )}
                    
                    {error && (
                        <div className="mb-6 p-4 bg-red-50 border border-red-100 rounded-xl flex items-center space-x-3 animate-pulse">
                            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
                            <span className="text-red-700 font-medium text-sm">{error}</span>
                        </div>
                    )}

                    {/* Input Section */}
                    <div className="space-y-6">
                        {/* Passcode Input */}
                        <div className="space-y-2">
                            <label className="block text-sm font-semibold text-gray-700">
                                Passcode
                            </label>
                            <div className="relative group">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10">
                                    <Lock className={`w-5 h-5 transition-all duration-200 ${
                                        isFocused ? 'text-[#020381]' : 'text-gray-400'
                                    }`} strokeWidth={2} />
                                </div>
                                <input
                                    type={showPasscode ? "text" : "password"}
                                    name="passcode"
                                    placeholder="••••••••"
                                    autoComplete="current-password"
                                    value={passcode}
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => setIsFocused(false)}
                                    className={`w-full pl-12 pr-12 py-3.5 bg-gray-50 border-2 rounded-xl focus:outline-none transition-all duration-200 text-base font-medium ${
                                        isFocused 
                                            ? 'border-[#020381] bg-white shadow-sm' 
                                            : 'border-gray-200 hover:border-gray-300'
                                    } ${error ? 'border-red-300 bg-red-50' : ''}`}
                                    required
                                    autoFocus
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPasscode(!showPasscode)}
                                    className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors z-10"
                                >
                                    {showPasscode ? 
                                        <EyeOff className="w-5 h-5" strokeWidth={2} /> : 
                                        <Eye className="w-5 h-5" strokeWidth={2} />
                                    }
                                </button>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <button
                            onClick={handleSubmit}
                            disabled={loading || !passcode.trim()}
                            className="w-full bg-[#020381] text-white font-semibold py-3.5 px-6 rounded-xl shadow-lg hover:shadow-xl hover:bg-[#030450] active:scale-[0.98] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-md flex items-center justify-center space-x-2 text-base"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="w-5 h-5 animate-spin" strokeWidth={2.5} />
                                    <span>Verifying...</span>
                                </>
                            ) : (
                                <>
                                    <ShieldCheck className="w-5 h-5" strokeWidth={2} />
                                    <span>Unlock</span>
                                </>
                            )}
                        </button>
                    </div>

                    {/* Footer */}
                    <div className="mt-8 pt-6 border-t border-gray-100">
                        <p className="text-center text-xs text-gray-500">
                            Protected for advanced security
                        </p>
                    </div>
                </div>

                {/* Decorative elements */}
                <div className="absolute -z-10 -top-24 -right-24 w-48 h-48 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full blur-3xl opacity-30"></div>
                <div className="absolute -z-10 -bottom-24 -left-24 w-48 h-48 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full blur-3xl opacity-30"></div>
            </div>
        </div>
    );
}

export default PasscodeLogin;